import React, {useRef} from "react";
import Select from "react-select";
import './dropdown.css';
import {expandSearch, isEmpty} from "../../../_helpers/commonFunctions";
import useDeviceType from "../../../hooks/useDeviceType";
import {useTranslation} from "../../../hooks/useTranslation";

const Dropdown = (props) => {
    const deviceType = useDeviceType();
    const colorStyles = {
        control: (styles) => ({
            ...styles,
            backgroundColor: "white",
            marginTop: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) ? "0" : "",
            paddingTop: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "0" : "",
            minHeight: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "35px" : "",
            maxHeight: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "35px" : "",
        }),
        valueContainer: (styles) => ({
            ...styles,
            marginTop: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "0" : "",
            paddingTop: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "0" : "",
            minHeight: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "35px" : "",
            maxHeight: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "35px" : "",
        }),
        input: (styles) => ({
            ...styles,
            marginTop: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "0" : "",
            paddingTop: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "0" : "",
            minHeight: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "35px" : "",
            maxHeight: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "35px" : "",
        }),
        indicatorsContainer: (styles) => ({
            ...styles,
            marginTop: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "0" : "",
            paddingTop: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "0" : "",
            minHeight: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "35px" : "",
            maxHeight: (props?.fromEditableTable === true && (isEmpty(props?.defaultValue) || props?.defaultValue?.length <= 1)) === true ? "35px" : "",
        }),
        option: (styles, {data, isSelected, isDisabled, isFocused}) => {
            return {
                ...styles,
                backgroundColor: isDisabled
                    ? null
                    : isSelected
                        ? "#76AEB7"
                        : isFocused
                            ? "#fff"
                            : null,
                color: isDisabled
                    ? "#ccc"
                    : isSelected
                        ? "#fff"
                            ? "white"
                            : "black"
                        : "#76AEB7",
                cursor: isDisabled ? "not-allowed" : "default",
                ":hover": {
                    color: "white",
                    backgroundColor: "#76AEB7",
                },
                ":active": {
                    ...styles[":active"],
                    backgroundColor:
                        !isDisabled && (isSelected ? "#76AEB7" : "#76AEB7"),
                },
            };
        },
        menuPortal: base => ({...base, zIndex: "9999 !important"}),
        menu: provided => ({...provided, zIndex: "9999 !important"}),
        multiValue: (base) => ({
            ...base,
            maxWidth: '400px',
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: "#fff",
            backgroundColor: "#76AEB7",
            borderRadius: 0,
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: "#fff",
            backgroundColor: "#76AEB7",
            borderRadius: 0,
            ":hover": {
                backgroundColor: "#49868f",
                color: "white",
            },
        }),
    };

    let classes = props.classes ? props.classes : props.className ? props.className : 'mb-3 w-100';
    let defaultValue = props.defaultValue ? props.defaultValue : null;
    const {t} = useTranslation();
    const ddRef = useRef(null);

    if (props.isCLientCategory) {
        props.options.forEach(option => {
            if (option.label === "Retail") {
                option.label = "Λιανικής";
            } else if (option.label === "Patient") {
                option.label = "Ασθενής";
            } else if (option.label === "Freelancer") {
                option.label = "Ελεύθερος Επαγγελματίας";
            } else if (option.label === "Non-Profit Organization") {
                option.label = "Μη κερδοσκοπική οργάνωση";
            } else if (option.label === "Client within E.U.") {
                option.label = "Πελάτης εντός Ε.Ε.";
            } else if (option.label === "Client outside E.U.") {
                option.label = "Πελάτης εκτός Ε.Ε.";
            } else if (option.label === "Supplier within E.U.") {
                option.label = "Προμηθευτής εντός Ε.Ε.";
            } else if (option.label === "Supplier outside E.U.") {
                option.label = "Προμηθευτής εκτός Ε.Ε.";
            } else if (option.label === "Wholesale Others") {
                option.label = "Λοιποί Χονδρικής";
            } else if (option.label === "E.P.E.") {
                option.label = "Ε.Π.Ε.";
            } else if (option.label === "Leads") {
                option.label = "Υποψήφιοι Πελάτες";
            }
        })
        if (defaultValue.label === "Retail") {
            defaultValue.label = "Λιανικής";
        } else if (defaultValue.label === "Patient") {
            defaultValue.label = "Ασθενής";
        } else if (defaultValue.label === "Freelancer") {
            defaultValue.label = "Ελεύθερος Επαγγελματίας";
        } else if (defaultValue.label === "Non-Profit Organization") {
            defaultValue.label = "Μη κερδοσκοπική οργάνωση";
        } else if (defaultValue.label === "Client within E.U.") {
            defaultValue.label = "Πελάτης εντός Ε.Ε.";
        } else if (defaultValue.label === "Client outside E.U.") {
            defaultValue.label = "Πελάτης εκτός Ε.Ε.";
        } else if (defaultValue.label === "Supplier within E.U.") {
            defaultValue.label = "Προμηθευτής εντός Ε.Ε.";
        } else if (defaultValue.label === "Supplier outside E.U.") {
            defaultValue.label = "Προμηθευτής εκτός Ε.Ε.";
        } else if (defaultValue.label === "Wholesale Others") {
            defaultValue.label = "Λοιποί Χονδρικής";
        } else if (defaultValue.label === "E.P.E.") {
            defaultValue.label = "Ε.Π.Ε.";
        } else if (defaultValue.label === "Leads") {
            defaultValue.label = "Υποψήφιοι Πελάτες";
        }
    }

    const handleOnInputChange = (inputString) => {
        if (inputString) {
            if (props.onChangeSearch) props.onChangeSearch(inputString);
            if (props.onKeyDown) props.onKeyDown(inputString);
        }
        return inputString;
    }

    const scrollToBottom = () => {
        if (!ddRef.current.children[0].className.includes("disabled") && props.autoscroll !== false) {
            ddRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                container: "nearest",
            })
        }
    }

    const customFilter = () => {
        if (["productIds", "clientIds", "supplierIds", "installation"].includes(props.name)) {
            return function (option, inputValue) {
                if (!inputValue) return true;
                return option;
            }
        } else if (props.name === "forCompany") {
            return function (option, inputValue) {
                if (!inputValue) return true;
                const expandedKeyword = expandSearch(inputValue);
                return expandedKeyword.test(option.label);
            }
        } else if (props.name === "countrySelection") {
            return function (option, inputValue) {
                if (!inputValue) return true;
                const normalize = (s) => String(s ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                return normalize(option?.data?.searchText || option.value).includes(normalize(inputValue));
            }
        }
    }

    return (
        <React.Fragment>
            <div className={classes} ref={ddRef} onClick={scrollToBottom}>
                {props.label &&
                    <label htmlFor={props.id} className="mr-1">
                        {props.label}
                        {props.required && <span className="text-danger"> *</span>}
                    </label>
                }
                {
                    <Select
                        name={props.name ? props.name : 'bottom'}
                        closeMenuOnSelect={true}
                        classNamePrefix={`${props.multiSelect === true ? "MULTI_SELECT_DO_NOT_TOUCH " : ""}scrollable-dropdown`}
                        placeholder={props.placeholder ? props.placeholder : t("SelectPlaceholder")}
                        value={props.enabledValue && props.value ? props.value : defaultValue}
                        defaultValue={defaultValue}
                        isMulti={props.multiSelect}
                        options={props.options}
                        filterOption={customFilter()}
                        styles={colorStyles}
                        isSearchable={(deviceType === "mobile" || deviceType === "tablet") ? false : props.searchEnable}
                        id={props.id}
                        onChange={props.onChange}
                        onInputChange={handleOnInputChange}
                        inputValue={props.inputValue}
                        isDisabled={props.disabled}
                        menuPlacement={props.position ? props.position : 'bottom'}
                        noOptionsMessage={() => "Δεν υπάρχουν επιλογές για αυτό το πεδίο"}
                        theme={(theme) => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                primary25: '#76AEB7',
                                primary: '#76AEB7',
                            },
                        })}
                        menuPosition="fixed"
                    />
                }
            </div>
        </React.Fragment>
    );
};

export default Dropdown;
